<template>
<div class="chapter">
<div class="inner_page">
<p class="sink"> </p>
<h1 class="chaptertitle parttitle">ERUNTICS</h1>
<p class="center ">
<b>Reginald Gulliver</b>
</p>
<p class="sink"> </p>
<p class="center "><b>George Allen &amp; Unwin Limited</b>
<br/>
<b>40 Museum Street, London</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c002.vue?134cb5f9